import { render, staticRenderFns } from "./default-info.vue?vue&type=template&id=9100143a&scoped=true&"
import script from "./default-info.vue?vue&type=script&lang=js&"
export * from "./default-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9100143a",
  null
  
)

export default component.exports